"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _OAuthCardContent = _interopRequireDefault(require("./OAuthCardContent"));

var OAuthCardAttachment = function OAuthCardAttachment(_ref) {
  var _ref$attachment = _ref.attachment;
  _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
  var content = _ref$attachment.content,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react.default.createElement(_OAuthCardContent.default, {
    content: content,
    disabled: disabled
  });
};

OAuthCardAttachment.defaultProps = {
  disabled: undefined
};
OAuthCardAttachment.propTypes = {
  attachment: _propTypes.default.shape({
    content: _propTypes.default.shape({
      buttons: _propTypes.default.array
    }).isRequired
  }).isRequired,
  disabled: _propTypes.default.bool
};
var _default = OAuthCardAttachment;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9hZGFwdGl2ZUNhcmRzL0F0dGFjaG1lbnQvT0F1dGhDYXJkQXR0YWNobWVudC5qcyJdLCJuYW1lcyI6WyJPQXV0aENhcmRBdHRhY2htZW50IiwiYXR0YWNobWVudCIsImNvbnRlbnQiLCJkaXNhYmxlZCIsImRlZmF1bHRQcm9wcyIsInVuZGVmaW5lZCIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsInNoYXBlIiwiYnV0dG9ucyIsImFycmF5IiwiaXNSZXF1aXJlZCIsImJvb2wiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUVBOztBQUVBLElBQU1BLG1CQUFtQixHQUFHLFNBQXRCQSxtQkFBc0I7QUFBQSw2QkFBR0MsVUFBSDtBQUFBLGlEQUE2QixFQUE3QjtBQUFBLE1BQWlCQyxPQUFqQixtQkFBaUJBLE9BQWpCO0FBQUEsTUFBaUNDLFFBQWpDLFFBQWlDQSxRQUFqQztBQUFBLHNCQUMxQiw2QkFBQyx5QkFBRDtBQUFrQixJQUFBLE9BQU8sRUFBRUQsT0FBM0I7QUFBb0MsSUFBQSxRQUFRLEVBQUVDO0FBQTlDLElBRDBCO0FBQUEsQ0FBNUI7O0FBSUFILG1CQUFtQixDQUFDSSxZQUFwQixHQUFtQztBQUNqQ0QsRUFBQUEsUUFBUSxFQUFFRTtBQUR1QixDQUFuQztBQUlBTCxtQkFBbUIsQ0FBQ00sU0FBcEIsR0FBZ0M7QUFDOUJMLEVBQUFBLFVBQVUsRUFBRU0sbUJBQVVDLEtBQVYsQ0FBZ0I7QUFDMUJOLElBQUFBLE9BQU8sRUFBRUssbUJBQVVDLEtBQVYsQ0FBZ0I7QUFDdkJDLE1BQUFBLE9BQU8sRUFBRUYsbUJBQVVHO0FBREksS0FBaEIsRUFFTkM7QUFIdUIsR0FBaEIsRUFJVEEsVUFMMkI7QUFNOUJSLEVBQUFBLFFBQVEsRUFBRUksbUJBQVVLO0FBTlUsQ0FBaEM7ZUFTZVosbUIiLCJzb3VyY2VSb290IjoiYnVuZGxlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgT0F1dGhDYXJkQ29udGVudCBmcm9tICcuL09BdXRoQ2FyZENvbnRlbnQnO1xuXG5jb25zdCBPQXV0aENhcmRBdHRhY2htZW50ID0gKHsgYXR0YWNobWVudDogeyBjb250ZW50IH0gPSB7fSwgZGlzYWJsZWQgfSkgPT4gKFxuICA8T0F1dGhDYXJkQ29udGVudCBjb250ZW50PXtjb250ZW50fSBkaXNhYmxlZD17ZGlzYWJsZWR9IC8+XG4pO1xuXG5PQXV0aENhcmRBdHRhY2htZW50LmRlZmF1bHRQcm9wcyA9IHtcbiAgZGlzYWJsZWQ6IHVuZGVmaW5lZFxufTtcblxuT0F1dGhDYXJkQXR0YWNobWVudC5wcm9wVHlwZXMgPSB7XG4gIGF0dGFjaG1lbnQ6IFByb3BUeXBlcy5zaGFwZSh7XG4gICAgY29udGVudDogUHJvcFR5cGVzLnNoYXBlKHtcbiAgICAgIGJ1dHRvbnM6IFByb3BUeXBlcy5hcnJheVxuICAgIH0pLmlzUmVxdWlyZWRcbiAgfSkuaXNSZXF1aXJlZCxcbiAgZGlzYWJsZWQ6IFByb3BUeXBlcy5ib29sXG59O1xuXG5leHBvcnQgZGVmYXVsdCBPQXV0aENhcmRBdHRhY2htZW50O1xuIl19